import { render } from "./EyesComponent.vue?vue&type=template&id=85662bde&scoped=true"
import script from "./EyesComponent.vue?vue&type=script&lang=js"
export * from "./EyesComponent.vue?vue&type=script&lang=js"

import "./EyesComponent.vue?vue&type=style&index=0&id=85662bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85662bde"]])

export default __exports__